'use client'

import classNames from 'classnames'
import styles from './QuestionAnswerBlock.module.scss'
import { useInView } from 'react-intersection-observer'
import { redirect } from 'next/navigation'
import { ROUTES_LINKS } from '@/shared/constants/links.js'
import { useEffect } from 'react'

export function QuestionAnswerBlock({ onMount }) {
    const navigate = (path) => redirect(path)
    const { ref, inView } = useInView({
        threshold: 0,
        triggerOnce: true,
    })

    useEffect(() => {
        onMount()
    }, [])

    return (
        <div
            onClick={() => navigate(ROUTES_LINKS.LINK_QUESTIONS)}
            ref={ref}
            className={classNames(
                styles.wrapper,
                inView && 'animate__animated animate__fadeIn'
            )}
        >
            <div className={classNames(styles.icon)}>
                <img src="/icons/homePage/faq.png" alt="FAQ" />
            </div>
            <div className={classNames(styles.text)}>Вопрос-ответ</div>
        </div>
    )
}
